import(/* webpackMode: "eager", webpackExports: ["ProductDetail"] */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/components/ProductDetail.tsx");
